import {Box, capitalize, FormControl, MenuItem, Select, SelectChangeEvent} from '@mui/material';
import {currency_atom, exchange_name_atom} from 'atoms';
import {get_exchange_list, save_cookie} from 'common';
import {request_recover_order} from 'connector/order';
import {useActiveOrders} from 'hooks/orderHooks';
import {useEffect, useState} from 'react';
import {useRecoilState} from 'recoil';

export default function ExchangeSelector() {
	const sel_list = get_exchange_list();

	const [cur_value, set_cur_value] = useState(sel_list[0]);
	const [exchange_name, set_exchange_name] = useRecoilState(exchange_name_atom);
	const [_, set_currency] = useRecoilState(currency_atom);
	const {refresh_orders} = useActiveOrders();

	useEffect(() => {
		if (sel_list.length > 0) {
			const exists = sel_list.includes(exchange_name.toLowerCase());
			if (exists) set_cur_value(exchange_name);
			else {
				set_cur_value(sel_list[0]);
				set_exchange_name(sel_list[0]);
			}

			if (exchange_name.toLowerCase() === 'binance') set_currency('USDT');
			else set_currency('KRW');
		}
	}, [sel_list, exchange_name, set_exchange_name]);

	const recover_orders = async (exchange: string) => {
		const resp = await request_recover_order(exchange);
		if (resp.data.is_recovered) refresh_orders();
	};

	const handleChange = (event: SelectChangeEvent) => {
		const exchange = event.target.value.toLowerCase();
		set_cur_value(exchange);
		set_exchange_name(exchange);
		save_cookie('exchange', exchange);

		recover_orders(exchange);
	};

	return (
		<Box>
			<FormControl>
				<Select
					size="small"
					value={cur_value}
					onChange={handleChange}
					sx={{
						height: '30px',
						fontSize: '0.8rem',
						'.MuiOutlinedInput-notchedOutline': {borderRadius: '4px'},
						'.MuiSelect-select': {padding: '2px 14px 2px 8px'},
					}}
					MenuProps={{
						PaperProps: {
							sx: {
								bgcolor: '#333333',
								maxHeight: 250,
								'& .MuiMenuItem-root': {
									color: '#ffffff',
									'&:hover': {bgcolor: '#444444'},
									'&.Mui-selected': {bgcolor: '#2c5282', '&:hover': {bgcolor: '#3b6eaa'}},
								},
							},
						},
					}}
				>
					{sel_list.map((cur_value, index) => (
						<MenuItem key={index} value={cur_value}>
							{capitalize(cur_value.toLowerCase())}
						</MenuItem>
					))}
				</Select>
			</FormControl>
		</Box>
	);
}
